import React from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { MaxBotPerRent, RentSubscriptions, SUB_STATUS, SUB_TIER } from "../../../Const";
import { getMonthlyPrice, getYearlyPrice } from "../../../utils/SubUtils";
import "./RentBotPremiumInfo.scss";
import { RentPlans } from "../../../Const";
import TutorialPopup from "../../help/TutorialPopup";
import { useTranslation } from "react-i18next";

const RentBotPremiumInfo = (props) => {
  const {
    isYearly,
    readOnly,
    onUpgrade,
    subStatus,
    subPremium,
    subTier,
    template,
    plan
  } = props;
  
  const history = useHistory();
  const {t} = useTranslation()

  // const clickUpgrade = () => {
  //   if (subStatus == SUB_STATUS.canceled) {
  //     onUpgrade && onUpgrade();
  //   } else if (
  //     !subPremium ||
  //     (subPremium && subTier === SUB_TIER.premium && tier === SUB_TIER.pro)
  //   ) {
  //     history.push(
  //       "/subscription?plan=" +
  //         (isYearly ? "yearly" : "monthly") +
  //         "&tier=" +
  //         tier
  //     );
  //   }
  // };
//   const clickUpgrade = () => {
//     history.push(
//       "/subscription?plan=" +
//         plan
//     );
//   };
  return (
    <div className="round-bg premium-info text-center">
      <div>
          <img src={template.image} width={200} className="template-thumbnail"></img>
        <div className="header">
          <h5 className="header-row">
            {template.title}
          </h5>
          <div className="header-row row justify-content-center align-items-center h-100">
            <h5 className="text-success">
                ${template[RentSubscriptions[plan]]}
            </h5> <span className="text-success"> /{t(RentPlans[plan])}</span>
           
          </div>
        </div>
        <div>
          <h6 className="text-row">
            <i className="fas fa-check-circle item-check"></i>{" "}
             {MaxBotPerRent} {t("active-bots")}<TutorialPopup content={t("max-bot-msg")} />
          </h6>
          {/* <h6 className="text-row">
            <i className="fas fa-check-circle item-check"></i>{" "}
            {tier == SUB_TIER.premium ? "3" : "5"} Connected Exchanges
          </h6> */}
        </div>
      </div>
    </div>
  );
};

export default RentBotPremiumInfo;
